<template>
  <div>
    <v-row>
        <v-col class="mt-2" cols="6" sm="6" md="3">
            <v-card :class="avarageDemand ? 'data-cards' : 'no-data-cards'" min-height="280" color="primary darken-1">
                <v-row class="ml-1">
                    <v-col cols="12" class="ml-1">
                    <v-icon style="color: lightgrey" left small>restore</v-icon>
                    <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
                    </v-col>
                </v-row>
                <v-card-title class="mt-n5">
                    <v-icon color="secondary lighten-1" class="mb-2" size="24">
                        mdi-waves
                    </v-icon>
                </v-card-title>
                <v-card-subtitle class="font-weight-bold white--text">Demanda média</v-card-subtitle>
                <v-card-text>
                    <v-row v-if="avarageDemand" class="white--text">
                        <v-col class="pr-0" cols="12">
                            <strong class="value-text">{{avarageDemand}}</strong>
                            <span class="ml-1 unit-measurement-text">l/s</span>
                        </v-col>
                        <v-col class="pt-0 pr-0" cols="12">
                            <span>Acumulado do mês de {{currentMonthFormat}}</span>
                        </v-col>
                    </v-row>
                    <v-row v-else  class="white--text">
                        <v-col class="pa-3" cols="12">
                            <h2>Em breve</h2>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

      <v-col class="mt-2" cols="6" sm="6" md="3">
        <v-card :class="basinsTendency ? 'data-cards' : 'no-data-cards'" min-height="280" color="primary darken-1">
          <v-row class="ml-1">
            <v-col cols="12" class="ml-1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary lighten-1" class="mb-2" size="24">
              mdi-arrow-expand-vertical
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Tendência dos reservatórios</v-card-subtitle>
          <v-card-text>
            <v-row v-if="basinsTendency" class="white--text">
              <v-col class="pr-0" cols="12" style="max-width: 120px;">
                <strong class="value-text">{{basinsTendency}}</strong>
              </v-col>
              <v-col class="pr-0" cols="12">
                <span>Baseado nos dados de volume de 2 dias atrás</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col class="pa-3" cols="12">
                <h2>Em breve</h2>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

        <v-col class="hidden-sm-and-down mt-2" cols="12" sm="4" md="3">
            <v-card :class="rainFromLastThirtydays ? 'data-cards' : 'no-data-cards'" color="primary darken-1">
                <v-row v-if="rainFromLastThirtydays" class="ml-1">
                    <v-col cols="12" class="ml-1">
                    <v-icon style="color: lightgrey" left small>restore</v-icon>
                    <span style="color: lightgrey; font-size: small">Atualizado em {{rainFromLastThirtydays.updated}}</span>
                    </v-col>
                </v-row>
                <v-card-title class="mt-n5">
                    <v-icon color="secondary lighten-1" class="mb-2" size="24">
                        mdi-weather-pouring
                    </v-icon>
                </v-card-title>
                <v-card-subtitle class="font-weight-bold white--text">Chuva dos últimos 30 dias</v-card-subtitle>
                <v-card-text>
                    <v-row v-if="rainFromLastThirtydays" class="white--text">
                        <v-col class="pr-0" cols="12">
                            <strong class="value-text">{{rainFromLastThirtydays.value}}</strong>
                            <span class="ml-1 unit-measurement-text">mm</span>
                        </v-col>
                        <v-col class="pt-0 pr-0" cols="12">
                            <span>Acumulado do últimos 30 dias</span>
                        </v-col>
                    </v-row>
                    <v-row v-else class="white--text">
                        <v-col class="pa-3" cols="12">
                            <h2>Em breve</h2>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col class="hidden-sm-and-down mt-2" cols="12" sm="4" md="3">
            <v-card :class="avarageClimatologyLastThirtyYears ? 'data-cards' : 'no-data-cards'" color="primary darken-1">
                <v-row v-if="avarageClimatologyLastThirtyYears" class="ml-1">
                    <v-col cols="12" class="ml-1">
                    <v-icon style="color: lightgrey" left small>restore</v-icon>
                    <span style="color: lightgrey; font-size: small">Atualizado em {{avarageClimatologyLastThirtyYears.updated}}</span>
                    </v-col>
                </v-row>
                <v-card-title class="mt-n5">
                    <v-icon color="secondary lighten-1" class="mb-2" size="24">
                        mdi-weather-pouring
                    </v-icon>
                </v-card-title>
                <v-card-subtitle class="font-weight-bold white--text">Média climatológica</v-card-subtitle>
                <v-card-text>
                    <v-row v-if="avarageClimatologyLastThirtyYears" class="white--text">
                        <v-col class="pr-0" cols="12">
                            <strong class="value-text">{{avarageClimatologyLastThirtyYears.value}}</strong>
                            <span class="ml-1 unit-measurement-text">mm</span>
                        </v-col>
                        <v-col class="pt-0 pr-0" cols="12">
                            <span>Média de 1979 - {{ currentYearFormat  }} do mês de {{currentMonthFormat}}</span>
                        </v-col>
                    </v-row>
                    <v-row v-else class="white--text">
                        <v-col class="pa-3" cols="12">
                            <h2>Em breve</h2>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: [
    'currentMonthFormat', 'currentYearFormat','suppliedPopulation', 'savedDemand', 'avarageDemand',
    'rainFromLastThirtydays', 'avarageClimatologyLastThirtyYears', 'basinsTendency'
  ],
  name: "SaicHydrologicalData",
  data(){
    return{
      yesterday: moment().subtract(1, 'days').format('DD/MM/YYYY')
    }
  },
  methods:{
  }
}
</script>

<style scoped>

.donut-data /deep/ .v-progress-circular__underlay{
    stroke: #D9D9D9 !important;
    border: 0px;
}

.label-text{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #FFFFFF;
}

.data-cards {
  min-height: 280px;
}

.no-data-cards {
  min-height: 200px;
}

.unit-measurement-text{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
}

.value-text{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 47px;
}

</style>
